<template>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" :append-to-body="true" width="30%" center>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="请选择" prop="region">
                <el-select v-model="ruleForm.region" placeholder="请选择是否通过">
                    <el-option label="通过" :value="1"></el-option>
                    <el-option label="拒绝" :value="2"></el-option>
                    <el-option label="被举报下架" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="ruleForm.region !== 1 && ruleForm.region" label="下架理由" prop="refuseVal">
                <el-input v-model="ruleForm.refuseVal"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitSetadminFn('ruleForm')">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { updateCircleStatusApi } from '@/api/circle'
export default {
    data() {
        return {
            centerDialogVisible: false,
            ruleForm: {
                region: '',
                refuseVal: ''
            },
            rules: {
                region: [{ required: true, message: '请选择审核结果', trigger: 'blur' }],
                refuseVal: [{ required: true, message: '请输入拒绝理由', trigger: 'blur' }]
            },
        }
    },
    props: {
        circleData: {
            type: Object,
            default: () => { }
        }
    },
    methods: {
        submitSetadminFn(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const opt = {
                        circleId: this.circleData.circleId,
                        auditStatus: this.ruleForm.region,
                        result: this.ruleForm.refuseVal.trim()
                    }
                    updateCircleStatusApi(opt).then(res => {
                        if (res.code == 200) {
                            this.centerDialogVisible = false
                            this.$emit('updataCircle')
                            this.ruleForm = { region: '', refuseVal: '' }
                            this.$message({ message: '操作成功~', type: 'success' });
                        } else {
                            this.$message.error(res.msg)
                        }
                    }).catch(err => {
                        this.$message.error('请求出错, 请重试~')
                    })
                } else {
                    this.$message.error('请填写拒绝理由')
                    return false
                }
            })
        }
    }
}
</script>

<style></style>
